import BaseCrudService from './BaseCrudService';

class NotificationsService extends BaseCrudService {
  constructor() {
    super('/api/notifications');
  }

  getNotifications({ limit = 10, onlyUnread = false } = {}) {
    const params = new URLSearchParams();
    if (limit) params.append('limit', String(limit));
    if (onlyUnread) params.append('onlyUnread', 'true');
    return this.customRequest('get', `?${params.toString()}`);
  }

  async getUnreadCount() {
    const result = await this.customRequest('get', 'unread-count');
    return result.count || 0;
  }

  markAsRead(id) {
    return this.customRequest('patch', `${id}/read`);
  }

  markAllAsRead() {
    return this.customRequest('patch', 'mark-all-read');
  }

  clearAll() {
    return this.customRequest('delete', 'clear-all');
  }

  deleteNotification(id) {
    return this.delete(id);
  }

  // Helper for development/testing
  create({ title, message, type = 'info', linkUrl, metadata }) {
    return this.customRequest('post', '', { title, message, type, linkUrl, metadata });
  }
}

export default new NotificationsService();
